import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "./ui/table";
import TableWithSearch from "./TableWithSearch";
import { getCurrentMonthYear, formatDateTime24, formatDateTime24New } from "@/utils/helpers";
import { nursingNotesPopupHeaders } from "@/utils/tablesData";

const NursingNoteTablePopup = ({ patientId, program }: any) => {
  const [nursingNotes, setNursingNotes] = useState([]);
  return (
    <TableWithSearch
      data={nursingNotes}
      setData={setNursingNotes}
      isColumnSelection
      columnPreferenceKey={`nursing-notes-popup-${patientId}-${program || "all"}`}
      apiDataKey="notes"
      url="/patients/nursing-note"
      params={{ 
        patientId: patientId, 
        date: getCurrentMonthYear(),
        ...(program ? { program } : {})
      }}
      columnHeaders={nursingNotesPopupHeaders}
      fetchCondition={!!patientId}
      filters={[]}
      filtersOptions={[]}
      isIncludeSearch
      searchPlaceholder="Search nursing notes..."
      setFilters={() => {}}
      isIgnoreSearchParams
      clickRow={() => {}}
      handleAction={() => {}}
      heading=""
      isActionColumn={false}
      viewData={nursingNotes.map((v:any)=> ({
        ...v, 
        createdBy : v?.createdBy?.name,
        dateTime: v?.dateTime ? formatDateTime24New(v.dateTime) : ""
      }))}
    />
    //  <Table>
    //           <TableHeader>
    //             <TableRow className="bg-gray-100 hover:bg-gray-100">
    //               <TableHead className="font-semibold text-gray-700">
    //                 Author
    //               </TableHead>
    //               <TableHead className="font-semibold text-gray-700">
    //                 Date & Time
    //               </TableHead>
    //               <TableHead className="font-semibold text-gray-700">
    //                 Duration (min)
    //               </TableHead>
    //               <TableHead className="font-semibold text-gray-700">
    //                 Program
    //               </TableHead>
    //               <TableHead className="font-semibold text-gray-700">
    //                 Care Type
    //               </TableHead>
    //               <TableHead className="font-semibold text-gray-700">
    //                 Type
    //               </TableHead>
    //               <TableHead className="font-semibold text-gray-700">
    //                 Content
    //               </TableHead>
    //               <TableHead className="font-semibold text-gray-700">
    //                 Added By
    //               </TableHead>
    //               <TableHead className="font-semibold text-gray-700">
    //                 Updated
    //               </TableHead>
    //             </TableRow>
    //           </TableHeader>
    //           <TableBody>
    //             {nursingNotes && nursingNotes?.map((note :any) => (
    //               <TableRow
    //                 key={note._id}
    //                 className="hover:bg-gray-50"
    //               >
    //                 {/* Author Column */}
    //                 <TableCell className="align-top text-sm text-gray-900">
    //                   {note.authorName}
    //                 </TableCell>

    //                 {/* Date & Time Column */}
    //                 <TableCell className="align-top text-sm text-gray-700">
    //                   <div className="flex flex-col gap-0.5">
    //                     <span>
    //                       {new Date(note.dateTime).toLocaleDateString('en-US', {
    //                         month: 'short',
    //                         day: 'numeric',
    //                         year: 'numeric',
    //                       })}
    //                     </span>
    //                     <span className="text-xs text-gray-500">
    //                       {new Date(note.dateTime).toLocaleTimeString('en-US', {
    //                         hour: '2-digit',
    //                         minute: '2-digit',
    //                       })}
    //                     </span>
    //                   </div>
    //                 </TableCell>

    //                 {/* Duration Column */}
    //                 <TableCell className="align-top text-sm text-gray-700">
    //                   {note.duration}
    //                 </TableCell>

    //                 {/* Program Column */}
    //                 <TableCell className="align-top text-sm text-gray-700">
    //                   {note.program?.toUpperCase() || '-'}
    //                 </TableCell>

    //                 {/* Care Type Column */}
    //                 <TableCell className="align-top text-sm text-gray-700">
    //                   {note.careType || '-'}
    //                 </TableCell>

    //                 {/* Type Column */}
    //                 <TableCell className="align-top text-sm text-gray-700">
    //                   {note.type || '-'}
    //                 </TableCell>

    //                 {/* Content Column */}
    //                 <TableCell className="align-top text-sm text-gray-700 max-w-md">
    //                   <div className="line-clamp-3">
    //                     {note.content}
    //                   </div>
    //                 </TableCell>

    //                 {/* Added By Column */}
    //                 <TableCell className="align-top text-sm text-gray-700">
    //                   {note.createdBy?.name || '-'}
    //                 </TableCell>

    //                 {/* Updated Column */}
    //                 <TableCell className="align-top text-xs text-gray-500">
    //                   {new Date(note.updatedAt).toLocaleDateString('en-US', {
    //                     month: 'short',
    //                     day: 'numeric',
    //                     year: 'numeric',
    //                   })}
    //                 </TableCell>
    //               </TableRow>
    //             ))}
    //           </TableBody>
    //         </Table>
  );
};

export default NursingNoteTablePopup;
